export const linkStyles = (props) =>({
    link: {
        textDecoration: 'none',
    },
    linkBtn: {
        backgroundColor: '#FFFFFF',
        border: '1.25px solid #536D70',
        borderRadius: '5px',
        width: '174px',
        height: '41px',
        padding: '2px 24px 2px 14px',
        marginRight: '0px',
        textAlign: 'center',
        boxShadow: 'none',
        color: '#337478',
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: '600',
        lineHeight: '13px',
        textTransform: 'uppercase',
        '&:hover': {
          backgroundColor: '#FFFFFF',
          boxShadow: 'none',
        },
    },
    guideIcon: {
        marginLeft: '7px',
        width: '17px',
        height: '14px',
    },
})